/*
  Madebymoji — sold-out NOTIFY ME control.

  Shows an underlined italic "NOTIFY ME" link (in the blue accent) in place of
  the buy button whenever the selected variant is unavailable, and wires it to
  Klaviyo Back-in-Stock. Toggles in sync with Dawn's variant switching by
  listening to the global `variantChange` pub/sub event.

  Klaviyo: the trigger button carries the `klaviyo-bis-trigger` class plus
  `data-variant-id` (Klaviyo's onsite script auto-binds to these). As a
  fallback we also call the onsite API directly on click. The onsite script is
  injected by snippets/moji-notify-me.liquid only when a public API key is set
  in theme settings.
*/
(function () {
  if (window.customElements.get('moji-notify-me')) return;

  class MojiNotifyMe extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.button = this.querySelector('.moji-notify');
      this.buyButtons = document.getElementById(`MojiBuyButtons-${this.sectionId}`);

      this.button?.addEventListener('click', (e) => this.onClick(e));

      // Sync with Dawn's variant switching when pub/sub is available.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event?.data || event.data.sectionId !== this.sectionId) return;
          const variant = event.data.variant;
          this.update(variant ? variant.available : false, variant ? variant.id : null);
        });
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    update(available, variantId) {
      if (variantId && this.button) this.button.dataset.variantId = variantId;
      this.hidden = available;
      if (this.buyButtons) this.buyButtons.classList.toggle('hidden', !available);
    }

    onClick(event) {
      event.preventDefault();
      const variantId = this.button.dataset.variantId;
      const klaviyo = window.klaviyo;
      if (klaviyo && typeof klaviyo.push === 'function') {
        // Klaviyo onsite Back-in-Stock form.
        klaviyo.push(['openBackInStock', { variant: variantId }]);
      } else {
        console.warn(
          '[Madebymoji] Klaviyo is not loaded. Add your Klaviyo public API key in Theme settings → Madebymoji to enable NOTIFY ME.'
        );
      }
    }
  }

  window.customElements.define('moji-notify-me', MojiNotifyMe);
})();
